import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSyncQueryCache } from 'api/aws/organizations_table/useSyncQueryCache'
import { baseUrl } from 'api/config'
// ^ you already use this in other places; it exposes syncTasksCacheAfterBatchUpdate
import { Task } from 'types'

type Vars = { task: Task; url: string }

async function deleteTaskImageApi({ task, url }: Vars) {
  const key = url.split('.amazonaws.com/')[1]
  const tableName = 'TASKS_TABLE'
  const fieldName = 'imageUrls'

  const res = await fetch(
    `${baseUrl}/aws/s3/delete?key=${encodeURIComponent(key)}&tableName=${tableName}` +
      `&PK=${task.PK}&SK=${task.SK}&fieldName=${fieldName}`,
    { method: 'DELETE' }
  )
  if (!res.ok) throw new Error('Deletion failed')
  return true
}

export function useDeleteTaskImage() {
  const queryClient = useQueryClient()
  const { syncTasksCacheAfterBatchUpdate } = useSyncQueryCache()

  return useMutation({
    mutationFn: deleteTaskImageApi,

    // --- OPTIMISTIC UPDATE ---
    onMutate: async ({ task, url }: Vars) => {
      await queryClient.cancelQueries({})

      // Use freshest task we have in cache if present
      const cached = queryClient.getQueryData<Task>(['task', task.PK, task.SK]) ?? task

      const nextTask: Task = {
        ...cached,
        imageUrls: (cached.imageUrls || []).filter(u => u !== url),
      }

      // Update everywhere this task appears (your helper handles it)
      syncTasksCacheAfterBatchUpdate(queryClient, [nextTask])

      // Pass for rollback
      return { prevTask: cached }
    },

    onError: (_err, _vars, ctx) => {
      if (ctx?.prevTask) {
        syncTasksCacheAfterBatchUpdate(queryClient, [ctx.prevTask])
      }
    },

    // onSettled: (_ok, vars) => {
    //   // Keep the single-task query fresh too
    //   const t = vars.task
    //   queryClient.invalidateQueries({ queryKey: ['task', t.PK, t.SK] })
    // },
  })
}
